module.exports = __webpack_public_path__ + "media/images/img-realestate-1-34c785b3.png";